interface IPitProps {
  style: React.CSSProperties;
}

const Pit: React.FC<IPitProps> = ({ style }) => {
  return (
    <>
      <div className="container" style={{ ...style }} />
      <style jsx>{`
        .container {
          position: absolute;
          height: 5px;
          top: 20px;
          width: 1px;
          background: #a2a2a2;
        }
      `}</style>
    </>
  );
};

export default Pit;
